

export const getFloorAndItsElevationsStats = (floorid, floorsAndElevations, markerCount) => {

    // filter the floor's elevation only to readd later in the end [note that if elevation is acting as floor then it would not be filtered out as it is the only entry point]
    var filteredElevations = [...floorsAndElevations];
    if (floorid in markerCount) {
        var newFilteredElevations = filteredElevations.filter((e) => e !== floorid && e !== '');
        filteredElevations = [...newFilteredElevations];
    }

    newFilteredElevations = filteredElevations.filter((e) => `${e}`.includes(floorid));
    filteredElevations = [...newFilteredElevations];

    // loop over markerCount and pick and choose elevation

    var filteredMarkerCount = {};
    for (const e of filteredElevations) {
        const eachFilterdMarkerCount = { ...markerCount };
        // eslint-disable-next-line no-loop-func
        Object.values(eachFilterdMarkerCount).filter((v) => `${v.floorid}`.includes(e)).forEach((v) => {
            const eachElevationMap = { [`${v.floorid}`]: v };
            filteredMarkerCount = { ...eachElevationMap, ...filteredMarkerCount };
        });

    }

    // now add floor count directly [note that if elevation is acting as floor, it couldn't be added as it cannot exist in markerCount]

    if (floorid in markerCount) {
        filteredMarkerCount = {
            ...filteredMarkerCount,
            ...{ [floorid]: markerCount[floorid] }
        };
    }

    var fullTotal = 0;
    var fullActive = 0;
    var fullDefects = 0;
    var fullElevations = 0;

    Object.values(filteredMarkerCount).forEach((v) => {
        var total = v["total"];
        var active = v["active"];
        var defects = v["defects"];
        var elevations = v["elevations"];

        fullTotal += total;
        fullActive += active;
        fullDefects += defects;
        fullElevations += elevations;
    });

    // other data extracted
    var fullComplete = fullTotal - fullActive - fullElevations;
    var percentageFullComplete = (fullComplete / (fullActive + fullComplete) * 100);

    return {
        floorid,
        fullTotal,
        fullActive,
        fullDefects,
        fullElevations,
        fullComplete,
        percentageFullComplete,
        type: ''
    }

}

export const getTotalFloorAndItsElevationsStats = (floorsAndElevations, markerCount, floorsMap) => {

    // calculate the numbers
    var allTotalMarker = 0;
    var allActiveMarker = 0;
    var allDefectMarker = 0;
    var allElevationMarker = 0;
    var allCompletedMarker = 0;

    const filteredFloorsAndElevationIds = [...floorsAndElevations].filter((id) => id !== '');
    // console.log(filteredFloorsAndElevationIds)
    const allFloorIds = Object.keys(floorsMap);
    // console.log(allFloorIds)
    const activeFloorsId = filteredFloorsAndElevationIds.filter((id) => allFloorIds.indexOf(id) !== -1);
    // console.log(activeFloorsId);



    activeFloorsId.forEach(eachFloorid => {
        const { fullTotal, fullActive, fullDefects, fullElevations, fullComplete } = getFloorAndItsElevationsStats(eachFloorid, floorsAndElevations, markerCount);
        allTotalMarker += fullTotal;
        allActiveMarker += fullActive;
        allDefectMarker += fullDefects;
        allElevationMarker += fullElevations;
        allCompletedMarker += fullComplete;
    });
    const overallCompletionPercentage = (allCompletedMarker / (allActiveMarker + allCompletedMarker) * 100);
    return {
        allTotalMarker,
        allActiveMarker,
        allDefectMarker,
        allElevationMarker,
        allCompletedMarker,
        overallCompletionPercentage,
        type: ''
    }
}